let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ge6Ol")).then(() => parcelRequire('5HAMb'));